import React from 'react';
import { TrainerLeftRail, type TrainerSection } from './TrainerLeftRail';
import './trainerShell.css';

export type TrainerAppLayoutProps = {
  activeSection: TrainerSection;
  onSectionSelect: (id: TrainerSection) => void;
  shellClassName?: string;
  mainClassName?: string;
  mainId?: string;
  mainStyle?: React.CSSProperties;
  children: React.ReactNode;
};

/**
 * Shared trainer web chrome: primary left rail + scrollable main column.
 * Hub (`TrainerDashboardLayout`) and drill-down routes use the same shell.
 */
export function TrainerAppLayout({
  activeSection,
  onSectionSelect,
  shellClassName = '',
  mainClassName = 'flex-1 flex flex-col overflow-hidden min-w-0',
  mainId,
  mainStyle,
  children,
}: TrainerAppLayoutProps) {
  return (
    <div className={`trainer-app-shell min-h-screen flex h-screen overflow-hidden ${shellClassName}`.trim()}>
      <TrainerLeftRail activeSection={activeSection} onSectionSelect={onSectionSelect} />
      <main id={mainId} className={mainClassName} style={mainStyle}>
        {children}
      </main>
    </div>
  );
}
